import api from '@/api/api'
import { getItem } from '@/utils/storage'
export default {
  notEmpty: /^[\s\S]*.*[^\s][\s\S]*$/,
  regName: /^([\u4E00-\u9FA5\uF900-\uFA2D]){2,20}|([a-zA-Z\s]){2,50}$/,
  regCheckCnMobile: /^1(3[0-9]|5[0-9]|8[0-9]|4[0-9]|7[0-9]|6[0-9]|9[0-9])\d{8}$/,
  regCheckComName: /^([\u4E00-\u9FA5\uF900-\uFA2D\\(\\)\\（\\）\\-\\《\\》\\&\\/\\\]|[a-zA-Z\d\s\\.\\,\\'\\_\\(\\)\\（\\）\\-\\《\\》\\&\\/\\]){4,100}$/,
  regId1: /^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$/,
  regId2: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
  passport1: /^[a-zA-Z]{5,17}$/,
  passport2: /^[a-zA-Z0-9]{5,17}$/,
  hkmakao: /^[HMhm]{1}([0-9]{10}|[0-9]{8})$/,
  taiwan1: /^[0-9]{8}$/,
  taiwan2: /^[0-9]{10}$/,
  // 验证 身份证
  regCId (regID) {
    var val = regID
    var isT = validateIdCard(val)
    return isT
    function validateIdCard (idCard) {
      if (getItem('tktIdType') === '身份证') {
        var vcity = { 11: '北京', 12: '天津', 13: '河北', 14: '山西', 15: '内蒙古', 21: '辽宁', 22: '吉林', 23: '黑龙江', 31: '上海', 32: '江苏', 33: '浙江', 34: '安徽', 35: '福建', 36: '江西', 37: '山东', 41: '河南', 42: '湖北', 43: '湖南', 44: '广东', 45: '广西', 46: '海南', 50: '重庆', 51: '四川', 52: '贵州', 53: '云南', 54: '西藏', 61: '陕西', 62: '甘肃', 63: '青海', 64: '宁夏', 65: '新疆', 71: '台湾', 81: '香港', 82: '澳门', 91: '国外' }
        if (idCard === '') {
          return false
        }
        if (isCardNo(idCard) === false) {
          return false
        }
        if (checkProvince(idCard, vcity) === false) {
          return false
        }
        if (checkBirthday(idCard) === false) {
          return false
        }
        if (checkParity(idCard) === false) {
          return false
        }
        return true
      } else {
        return true
      }
    }
    function isCardNo (card) {
      var reg = /(^\d{15}$)|(^\d{17}(\d|X|x)$)/
      if (reg.test(card) === false) {
        return false
      }
      return true
    }
    function checkProvince (card, vcity) {
      var province = card.substr(0, 2)
      if (vcity[province] === undefined) {
        return false
      }
      return true
    }
    function checkBirthday (card) {
      var len = card.length
      var arrData, year, month, day, birthday, reEighteen
      if (len === 15) {
        reEighteen = /^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/
        arrData = card.match(reEighteen)
        year = arrData[2]
        month = arrData[3]
        day = arrData[4]
        birthday = new Date('19' + year + '/' + month + '/' + day)
        return verifyBirthday('19' + year, month, day, birthday)
      }
      if (len === 18) {
        reEighteen = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X|x)$/
        arrData = card.match(reEighteen)
        year = arrData[2]
        month = arrData[3]
        day = arrData[4]
        birthday = new Date(year + '/' + month + '/' + day)
        return verifyBirthday(year, month, day, birthday)
      }
      return false
    }
    function verifyBirthday (year, month, day, birthday) {
      var now = new Date()
      var nowYear = now.getFullYear()
      if (birthday.getFullYear() === parseInt(year) && (birthday.getMonth() + 1) === parseInt(month) && birthday.getDate() === parseInt(day)) {
        var time = nowYear - year
        if (time >= 0 && time <= 100) {
          return true
        }
        return false
      }
      return false
    }
    function checkParity (card) {
      card = changeFivteenToEighteen(card)
      var len = card.length
      if (len === 18) {
        var arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
        var arrCh = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']
        var cardTemp = 0
        var i
        var valnum
        for (i = 0; i < 17; i++) {
          cardTemp += card.substr(i, 1) * arrInt[i]
        }
        valnum = arrCh[cardTemp % 11]
        if (valnum === card.substr(17, 1).toLocaleUpperCase()) {
          return true
        }
        return false
      }
      return false
    }
    function changeFivteenToEighteen (card) {
      if (card.length === '15') {
        var arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
        var arrCh = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']
        var cardTemp = 0
        var i
        card = card.substr(0, 6) + '19' + card.substr(6, card.length - 6)
        for (i = 0; i < 17; i++) {
          cardTemp += card.substr(i, 1) * arrInt[i]
        }
        card += arrCh[cardTemp % 11]
        return card
      }
      return card
    }
  },
  realNameVerification (that, name, idCard) {
    return new Promise((resolve, reject) => {
      api.GetValidationToken().then(restoken => {
        if (restoken.data.Status === 'OK') {
          api.CheckValidation({
            Name: name,
            IDNum: idCard,
            Code: '2021KLGF',
            APPKey: restoken.data.AppTokenKey,
            AppValue: restoken.data.AppTokenValue
          }).then(valres => {
            if (valres.data.Status === 'OK') {
              if (valres.data.result === 'false') {
                that.$toast.fail('您输入的姓名与身份证号不一致')
                that.btnLoading = false
              }
              resolve(valres.data.result)
            } else {
              that.$toast.fail(valres.data.Msg)
              that.btnLoading = false
            }
          })
        } else {
          that.$dialog.alert({
            title: '',
            message: 'token获取失败，请重新获取'
          })
            .then(() => {
              api.GetValidationToken()
                .then(restoken => {
                  if (restoken.data.Status === 'OK') {
                    api.CheckValidation({
                      Name: name,
                      IDNum: idCard,
                      Code: '2021KLGF',
                      APPKey: restoken.data.AppTokenKey,
                      AppValue: restoken.data.AppTokenValue
                    }).then(valres => {
                      if (valres.data.Status === 'OK') {
                        if (valres.data.result === 'false') {
                          that.$toast.fail('您输入的姓名与身份证号不一致')
                          that.btnLoading = false
                        }
                        resolve(valres.data.result)
                      } else {
                        that.$toast.fail(valres.data.Msg)
                        that.btnLoading = false
                      }
                    })
                  } else {
                    that.$toast.fail(restoken.data.Msg)
                    that.btnLoading = false
                  }
                })
            })
        }
      })
    })
  }
}
